// Message types for worker communication
// Used in both worker.js and gpxWorker.js

export const MESSAGE_TYPES = {
  REQUEST: {
    PROCESS_GPX_FILE: "PROCESS_GPX_FILE",
    FIND_POINTS_AT_DISTANCES: "FIND_POINTS_AT_DISTANCES",
    GET_ROUTE_SECTION: "GET_ROUTE_SECTION",
    FIND_CLOSEST_LOCATION: "FIND_CLOSEST_LOCATION",
    GENERATE_AUDIO_FRAMES: "GENERATE_AUDIO_FRAMES",
    RECALIBRATE: "RECALIBRATE",
  },
  RESPONSE: {
    GPX_FILE_PROCESSED: "GPX_FILE_PROCESSED",
    POINTS_FOUND: "POINTS_FOUND",
    ROUTE_SECTION_READY: "ROUTE_SECTION_READY",
    CLOSEST_POINT_FOUND: "CLOSEST_POINT_FOUND",
    AUDIO_FRAMES_READY: "AUDIO_FRAMES_READY",
    RECALIBRATED: "RECALIBRATED",
    PROGRESS: "PROGRESS",
    ERROR: "ERROR",
  },
};

export const SUCCESS_RESPONSE_TYPES = new Set([
  MESSAGE_TYPES.RESPONSE.GPX_FILE_PROCESSED,
  MESSAGE_TYPES.RESPONSE.POINTS_FOUND,
  MESSAGE_TYPES.RESPONSE.ROUTE_SECTION_READY,
  MESSAGE_TYPES.RESPONSE.CLOSEST_POINT_FOUND,
  MESSAGE_TYPES.RESPONSE.AUDIO_FRAMES_READY,
  MESSAGE_TYPES.RESPONSE.RECALIBRATED,
]);
